import ReactMarkdown from 'react-markdown'
import { GetServerSideProps } from 'next'
import { addApolloState, initializeApollo } from '@/graphql/apollo-client'
import { PolicyDocument, PolicyQuery, PolicyQueryVariables } from '@/graphql/queries/policy.generated'
import { PolicyType } from '@/graphql/types.generated'
import { NextPageWithLayout } from '../_app'
import Layout from '@/components/layout'

interface PolicyProps {
  body: string
}
const Policy: NextPageWithLayout<PolicyProps> = ({ body }) => {
  return (
    <section className="px-4 my-4">
      <div className="max-w-3xl mx-auto prose">
        <ReactMarkdown>{body}</ReactMarkdown>
      </div>
    </section>
  )
}

export const getServerSideProps: GetServerSideProps = async (context) => {
  if (context.params === undefined) {
    // TODO: render
    throw new Error('No params')
  }

  let type = context.params.type as string
  if (type === 'service') {
    type = 'term'
  }

  const apolloClient = initializeApollo(null, context)
  const response = await apolloClient.query<PolicyQuery, PolicyQueryVariables>({
    query: PolicyDocument,
    variables: {
      filter: {
        type: type.toUpperCase() as PolicyType
      }
    }
  })

  const body = response.data.policies.edges[0].node.body

  return addApolloState(apolloClient, { props: { body } })
}

Policy.getLayout = (page, options) => {
  const device = options?.device ?? { isMobileOnly: false, isIOS: false, isAndroid: false }
  return (
    <Layout device={device}>
      {page}
    </Layout>
  )
}

export default Policy
